import { render, staticRenderFns } from "./dripicons.vue?vue&type=template&id=f2213b52"
import script from "./dripicons.vue?vue&type=script&lang=js"
export * from "./dripicons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports